export default "/assets/images/mila-filters.png?020ffc8b355fb93fb54b94023020d01c";